var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.7172 4.11241L2.88699 11.0374C1.7383 11.529 1.74511 12.2125 2.67761 12.5173L6.87512 13.9149L8.48119 19.1678C8.67644 19.7427 8.58019 19.9708 9.14613 19.9708C9.58288 19.9708 9.77663 19.7583 10.0199 19.5049C10.1746 19.3434 11.093 18.3908 12.1185 17.3271L16.4847 20.7685C17.2882 21.2414 17.8683 20.9964 18.0683 19.9725L20.9344 5.5645C21.2278 4.3095 20.4859 3.74023 19.7172 4.11241ZM7.53387 13.5938L16.9951 7.22602C17.4674 6.92045 17.9005 7.08474 17.5449 7.42144L9.44363 15.219L9.12819 18.808L7.53387 13.5938Z",
  fill: "white"
})));
export default SvgIconTelegram;